<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'Swift Flight School',
    meta: [
      {
        property: 'og:title',
        content: 'Swift Flight School'
      },
      {
        property: 'og:description',
        content: 'Swift is looking for interns with infinite potential. Apply by March 26th.'
      },
      {
        property: 'og:link',
        content: 'https://flightschool.swift.co'
      }
    ],
    link: [
      { rel: 'favicon', href: 'assets/favicon.ico' }
    ]
  }
}
</script>

<style lang="scss">

</style>
